import React from 'react';

export const StoreTemplatesHero: React.FC = () => {
  return (
    <>
      <div className="mb-4">
        <img
          src="CanvaHero.svg"
          style={{
            backgroundSize: ' cover',
            backgroundRepeat: 'no-repeat',
          }}
          alt="Canva Templates"
          width="100%"
        />
      </div>
    </>
  );
};
